import { render } from "./LongFormPanel.vue?vue&type=template&id=04a6e26d&scoped=true"
import script from "./LongFormPanel.vue?vue&type=script&lang=js"
export * from "./LongFormPanel.vue?vue&type=script&lang=js"

import "./LongFormPanel.vue?vue&type=style&index=0&id=04a6e26d&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04a6e26d"]])

export default __exports__